import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createH5Block, createPBlock } from "../../utils/textBlocksHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "faqItem",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH5Block({
          text: "How is this different from other coaching programs?",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Our coaching program stands out because it goes beyond one-time sessions. We provide ongoing support, an engaged community, and real-time guidance to ensure lasting results, not just temporary motivation.",
        }),
      ],
    },
  },
};
